﻿import React from 'react';
import PropTypes from 'prop-types';
import { Tag, Intent } from "@blueprintjs/core";
import './Status.css';
import './EmployeeCircleStatus.css';
import './StatusPanel.css';

export function TagList(
    {
        disabled = false,
        items = [],
        onRemoveTag = null
    }
) {

    return (
        <div className="tag-list spacer-bottom-small">
            {items && items.map((item) => {
                return (<Tag key={item.name} intent={Intent.PRIMARY} size="large" onRemove={disabled || onRemoveTag == null ? null : (event) => { onRemoveTag(event, item.id) }}>{item.name}</Tag>);
            })}
        </div>
    );
}

TagList.propTypes = {
    disabled: PropTypes.bool,
    items: PropTypes.array,
    onRemoveTag: PropTypes.func
};